import RTGoogleAnalyticsManager from 'common/RTGoogleAnalyticsManager';

export function enableFooterStyleForSignup(enable) {
  if (enable) {
    window.document.body.style.backgroundColor = '#E7ECF3';
    window.document.documentElement.style.backgroundColor = '#E7ECF3';
  } else {
    window.document.body.style.backgroundColor = null;
    window.document.documentElement.style.backgroundColor = null;
  }
}
export function markSignupComplete() {
  localStorage.setItem('rt-signup-complete', true);
}

export function isSignupComplete() {
  return localStorage.getItem('rt-signup-complete') == 'true';
}

export function finishSignUpFlow(role) {
  RTGoogleAnalyticsManager.sendGA4Event('finished_signup_flow', '',  role);
}